import { Snackbar, Spinner } from "components";
import PropTypes from "prop-types";
import React from "react";
import LoadingOverlay from "react-loading-overlay";
import styled from "styled-components";

LoadingOverlay.propTypes = undefined;

const StyledLoader = styled(LoadingOverlay)`
  height: 100%;
  margin: 0;
  padin.MyLoader_overlay {
    background: #eeeeee9c;
    color: black !important;
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

export default function Page(props) {
  const { notificacion, closeNotification, loading, children, autoHeight } = props;

  return (
    <StyledLoader
      classNamePrefix="MyLoader_"
      active={loading}
      spinner={<Spinner loading={loading} />}
    >
      <div
        style={{
          width: "unset",
          height: autoHeight ? "auto" : "calc(100vh - 95px)",
          position: "relative",
          overflow: autoHeight ? "visible" : "auto"
        }}
      >
        <Snackbar
          color={notificacion.color}
          message={notificacion.errorGeneral}
          open={notificacion.open}
          closeNotification={() => closeNotification()}
        />
        {children}
      </div>
    </StyledLoader>
  );
}

Page.propTypes = {
  md: PropTypes.number,
  node: PropTypes.node,
  children: PropTypes.node,
  closeNotification: PropTypes.func,
  notificacion: PropTypes.object,
  loading: PropTypes.bool,
  autoHeight: PropTypes.bool
};
